import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { createQueryParams } from '../secure/common/helpers';
import { BillingSessionResponse, LocationAccessEmailDomain, PatchLocationDomainsRequest } from '../types/customer-portal';
import { PosthogService } from './posthog.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerPortalService {
  apiHost = `${environment.apiBaseUrl}`;

  private httpClient = inject(HttpClient);
  private posthogService = inject(PosthogService);

  getLocationDomains(location_id: number): Observable<LocationAccessEmailDomain[]> {
    const query = createQueryParams({ location_id: location_id.toString() });
    const requestUrl = `${this.apiHost}/CustomerPortal/GetLocationDomains?${query}`;
    return this.httpClient.get<LocationAccessEmailDomain[]>(requestUrl);
  }

  addLocationDomain(request: PatchLocationDomainsRequest) {
    const requestUrl = `${this.apiHost}/CustomerPortal/AddLocationDomain`;
    return this.httpClient.post(requestUrl, request);
  }

  removeLocationDomain(request: PatchLocationDomainsRequest) {
    const requestUrl = `${this.apiHost}/CustomerPortal/RemoveLocationDomain`;
    return this.httpClient.patch(requestUrl, request);
  }

  createSession(customerId: string): Observable<BillingSessionResponse> {
    return this.httpClient.get<BillingSessionResponse>(`${this.apiHost}/CustomerPortal/CreateSession`, {
      params: {
        customer_id: customerId,
      },
    });
  }

  createFlywireSession(branchId: number): Observable<BillingSessionResponse> {
    return this.httpClient.get<BillingSessionResponse>(`${this.apiHost}/CustomerPortal/CreateFlywireSession`, {
      params: {
        branch_id: branchId.toString(),
      },
    });
  }

  createBillingSession(branchId: number): Observable<BillingSessionResponse> {
    return this.httpClient.get<BillingSessionResponse>(`${this.apiHost}/CustomerPortal/CreateBillingSession`, {
      params: {
        branch_id: branchId.toString(),
      },
    });
  }
}
